import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import PrepaymentRequestModalUI from './PrepaymentRequestModalUI'

class PrepaymentRequestModalSF extends Component {
	constructor(props) {
		super(props)
		this.state = {
			successMsg: null,
			errorList: null,
			submitted: false,
			status: null,
			requestDate: '',
			requestDateError: null,
		}
	}

	render() {
		return (
			<PrepaymentRequestModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}
				// modes
				prepaymentRequestMode={this.props.prepaymentRequestMode}
				submitted={this.state.submitted}
				status={this.state.status}
				// event handlers
				onSubmit={this.onSubmit}
				onPrepaymentRequestCancel={this.props.onPrepaymentRequestCancel}
				// form fields
				requestDate={this.state.requestDate}
				onRequestDateChange={(requestDate) => { this.setState({ requestDate }) }}
				requestDateError={this.state.requestDateError}
				setRequestDateError={(error) => { this.setState({ requestDateError: error }) }}
			/>
		)
	}

	componentDidMount() {
		Modal.setAppElement('body')
	}

	onSubmit = (event) => {
		event.preventDefault();
		if (this.state.submitted) return;

		const { context, loan } = this.props;

		this.setState({
			successMsg: null,
			errorList: [],
			submitted: true
		});
		RestApiUtils.put(
			context,
			`/api/su/loans/${loan.loanId}/prepayments/clientRequest`,
			this.onSubmitCallback, {
				requestDateISO: this.state.requestDate,
			}
		);
	}


	onSubmitCallback = (response) => {
		let errorList = [];
		if (response.errorList) {
			response.errorList.forEach(error => {
				errorList.push(error.message);
			});
		}

		this.setState({
			successMsg: response.success,
			errorList: errorList,
			submitted: false
		});

		if (response.errorList && response.errorList.length === 0) {
			this.props.onPrepaymentRequestCancel();
		}
	}

	setErrorList = (errorList) => {
		this.setState({ errorList: errorList })
	}
}

export default PrepaymentRequestModalSF
